module.exports = "/_next/static/images/ConsistentData-304982d5f024c973940117ec7c90c78d.webp";